
import { defineComponent } from "vue";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Button from "primevue/button";
import * as FacebookServices from "../api/helpers/Facebook";

export default defineComponent({
  name: "Faq",
  components: {
    AccordionTab,
    Accordion,
    Button
  },
  data() {
    return {
      name: process.env.VUE_APP_TITLE,
    };
  },
  mounted() {
    FacebookServices.pageView();
    document.title = process.env.VUE_APP_TITLE + " | Preguntas frecuentes";
    window.scrollTo(0, 0);
  },
});
